import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import { setterReducer, toggleReducer } from 'frontend/state/utils';
import types from 'frontend/state/actionTypes';

export default combineReducers({
  simcExpertMode: toggleReducer({
    toggle: types.TOGGLE_SIMC_EXPERT_MODE,
    initial: false,
  }),
  header: setterReducer({
    set: types.INPUT_EXPERT_HEADER,
    initial: '',
  }),
  preActors: setterReducer({
    set: types.INPUT_EXPERT_PRE_ACTORS,
    initial: '',
  }),
  postActors: setterReducer({
    set: types.INPUT_EXPERT_POST_ACTORS,
    initial: '',
  }),
  footer: setterReducer({
    set: types.INPUT_EXPERT_FOOTER,
    initial: '',
  }),
});

const baseSelector = state => state.simbot.simcExpertOptions;
const simcExpertModeSelector = state => baseSelector(state).simcExpertMode;
const headerSelector = state => baseSelector(state).header;
const preActorsSelector = state => baseSelector(state).preActors;
const postActorsSelector = state => baseSelector(state).postActors;
const footerSelector = state => baseSelector(state).footer;

const returnInputIfExpertEnabled = (expertMode, input) => {
  if (expertMode) {
    return input;
  }
  return undefined;
};

const headerInputSelector = createSelector(
  simcExpertModeSelector,
  headerSelector,
  returnInputIfExpertEnabled,
);
const preActorsInputSelector = createSelector(
  simcExpertModeSelector,
  preActorsSelector,
  returnInputIfExpertEnabled,
);
const postActorsInputSelector = createSelector(
  simcExpertModeSelector,
  postActorsSelector,
  returnInputIfExpertEnabled,
);
const footerInputSelector = createSelector(
  simcExpertModeSelector,
  footerSelector,
  returnInputIfExpertEnabled,
);

const isExpertActiveSelector = createSelector(
  headerInputSelector,
  preActorsInputSelector,
  postActorsInputSelector,
  footerInputSelector,
  (header, preActors, postActors, footer) => {
    return header || preActors || postActors || footer;
  },
);

export const selectors = {
  simcExpertMode: simcExpertModeSelector,
  header: headerSelector,
  preActors: preActorsSelector,
  postActors: postActorsSelector,
  footer: footerSelector,

  headerInput: headerInputSelector,
  preActorsInput: preActorsInputSelector,
  postActorsInput: postActorsInputSelector,
  footerInput: footerInputSelector,

  isExpertActive: isExpertActiveSelector,
};
